export const ES = {
    translations: {
        notifications: 'Notificaciones',
        markAllAsRead: 'marcar todo como leído',
        poweredBy: 'Con tecnología de',
        settings: 'Configuración',
        noNewNotification: 'Nada nuevo que ver aquí todavía',
    },
    lang: 'es',
};
//# sourceMappingURL=es.js.map